import classNames from 'classnames'
import Slide from './slide'

export default function CoverSlide({
  data,
  images = [],
  width,
  height,
  className,
  imgClassName,
  alt = '',
  children
}) {
  if (images.length === 0) {
    return children
  }

  return (
    <div className={classNames('relative h-full', className)}>
      <div className='absolute inset-0 z-[3]'>
        <Slide
          data={data}
          images={images}
          width={width}
          height={height}
          imgClassName={imgClassName}
          alt={alt}
        >
          {children}
        </Slide>
      </div>
    </div>
  )
}